// extracted by mini-css-extract-plugin
export default {"zoomModal":"Y2-z","image":"Z2-z","button":"_2-z","isOverlayShown":"a3-z"};